<!-- table-control.component.html -->
<div>
  <!-- Search Control -->
    <div class="mb-3" style="position: relative">
        <div class="row">
            <div class="col-11">
                <input type="search" class="form-control" placeholder="Search..."
                       *ngIf="isPageable || data.length > 0"
                       [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
            </div>
            <div class="col-1">
                <button [appTooltip]="'Export ' + sheetName" *ngIf="data.length > 0" class="btn btn-outline-success float-end" (click)="exportToExcel()" [disabled]="pageDataReloadMode === 'loading'">
                    <i class="bi bi-file-earmark-spreadsheet"></i>
                </button>
            </div>
        </div>

        <div *ngIf="globalSelectedItems.length > 0" style="position: absolute">
          <span class="badge" style="background-color: #f8d7da; color: #b02a37;">
            {{ globalSelectedItems.length }} selected items
          </span>
        </div>
  </div>


  <!-- Table + Mobile wrapper with loading overlay -->
  <div class="table-wrapper">

  <!-- Loading overlay -->
  <div class="loading-overlay" *ngIf="pageDataReloadMode === 'loading'">
    <div class="loading-spinner-box">
      <div class="spinner-border loading-spinner-icon" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <span class="loading-spinner-text">Loading data…</span>
    </div>
  </div>

  <!-- Table -->
  <div class="table-container table-responsive" *ngIf="!isMobileView">
    <table class="table table-striped table-bordered table-hover">
        <thead class="head-table" style="white-space: nowrap !important;">
          <tr>
            <!-- Checkbox column if enabled -->
            <th *ngIf="showCheckboxes" class="text-center col-checkbox">
              <input class="checkbox" *ngIf="isMultiSelect && data.length > 0" type="checkbox" [(ngModel)]="selectAll"
                [checked]="currentFilterSelectAll" (change)="toggleSelectAll()"
                [indeterminate]="visibleSelectedItems.length > 0 && !currentFilterSelectAll">
            </th>

            <!-- Dynamic columns -->
            <th *ngFor="let col of visibleColumns" [style.width.px]="col.width !== undefined ? col.width : null"
                [style.maxWidth.px]="col.maxWidth !== undefined ? col.maxWidth : null" 
                [style.minWidth.px]="col.width !== undefined ? col.width : null" 
                [class.sortable]="col.sortable !== false"
                [class.sorted]="currentSortColumn === col.key"
                [class.sorted-asc]="currentSortColumn === col.key && isSortAscending"
                [class.sorted-desc]="currentSortColumn === col.key && !isSortAscending"
                style="white-space: nowrap;"
                (click)="col.sortable !== false && sortData(col.key)">
              {{ col.header }}
              <span *ngIf="currentSortColumn === col.key" class="sort-icon">
                {{ isSortAscending ? '↑' : '↓' }}
              </span>
            </th>

            <!-- Action column header if enabled -->
            <th *ngIf="showActions" class="actions-column-header  text-center" [style.width.px]="1">
            <div>
Actions
            </div>
              
            </th>
          </tr>
        </thead>
        <tbody>
          <tr [class]="getRowClass(item)" *ngFor="let item of paginatedData">
            <!-- Checkbox cell if enabled -->
            <td *ngIf="showCheckboxes" class="text-center col-checkbox">
              <input class="checkbox" type="checkbox" [checked]="isSelected(item)" (change)="toggleItemSelection(item)">
            </td>

            <!-- Data cells -->
            <td *ngFor="let col of visibleColumns" 
                [style.maxWidth.px]="col.maxWidth !== undefined ? col.maxWidth : null" 
                [style.width.px]="col.width !== undefined ? col.width : null"
                [style.minWidth.px]="col.width !== undefined ? col.width : null"
                [appTooltip]="col.tooltip && col.tooltip(item[col.key], item)"
                class="no-wrap text-v-center {{ getColClass(col, item) }}">
              <!-- {{ item[col.key] }} -->
              <div *ngIf="!col.render && !col.renderComponent">
                {{ getFormattedValue(col, item[col.key], item) }}
              </div>

              <!-- Function-based rendering -->
              <div
                [innerHTML]="col.render(getFormattedValue(col, item[col.key], item), item) | safeHtml"
                *ngIf="col.render && !col.renderComponent">
              </div>

              <!-- Component-based rendering -->
              <ng-container *ngIf="col.renderComponent && !col.render">
                <ng-container *ngComponentOutlet="col.renderComponent; 
                                     inputs: { 
                                       value: item[col.key], 
                                       row: item,
                                       onClick: col.onClick 
                                     }">
                </ng-container>
              </ng-container>
            </td>

            <!-- Action buttons if enabled -->
            <td *ngIf="showActions" class="actions-column text-center" [style.width.px]="1">
              
              <div style="display: flex; gap: 5px;">
                <button *ngFor="let btn of actionButtons" type="button" class="btn btn-{{ getButtonClass(btn, item) }} d-flex gap-2"
                        [appTooltip]="getButtonTooltip(btn, item)"
                        [disabled]="isButtonDisabled(btn, item)"
                        [hidden]="isButtonHidden(btn, item)"
                        (click)="onActionClick(getButtonLabel(btn, item), item)">
                  <i *ngIf="getButtonIcon(btn, item)" class="{{ getButtonIcon(btn, item) }}"></i>
                  <span *ngIf="btn.showLabel">{{ getButtonLabel(btn, item) }}</span>
                </button>
              </div>
            </td>
          </tr>

          <!-- Empty state -->
          <tr *ngIf="filteredData.length === 0">
              <td [attr.colspan]="visibleColumns.length + (showCheckboxes ? 1 : 0) + (showActions ? 1 : 0)" class="text-center">
                @if (!isPageable || pageDataReloadMode === 'loaded') {
                  No records found
                }
                @else {
                  Loading...
                }
              </td>
          </tr>
        </tbody>
      </table>
    
  </div>

  <!-- Mobile Card View -->
  <div *ngIf="isMobileView" class="card-view">
    <div *ngFor="let item of paginatedData" class="card mb-3">
      <div class="card-body">
        <!-- Checkbox if enabled -->
        <div *ngIf="showCheckboxes" class="form-check mb-5">
          <input class="form-check-input" type="checkbox" [checked]="isSelected(item)"
            (change)="toggleItemSelection(item)">
        </div>

        <!-- Data rows -->
        <div *ngFor="let col of visibleColumns" class="card-row">
          <strong class="card-label">{{ col.header }}:</strong>
          <span class="card-value" *ngIf="!col.render">
            {{ item[col.key] }}
          </span>

          <!-- Function-based rendering -->
          <span [innerHTML]="col.render(item[col.key], item) | safeHtml" *ngIf="col.render"></span>
        </div>

        <!-- Action buttons -->
        <div *ngIf="showActions" class="card-actions mt-2" style="display: flex; justify-content: center;">
          <button *ngFor="let btn of actionButtons" class="btn btn-sm btn-{{btn.class}} me-1 mb-1">
            <i *ngIf="btn.icon" class="{{btn.icon}}"></i> <span *ngIf="btn.label">{{ btn.label }}</span>

          </button>
        </div>
      </div>
    </div>

  </div>

  </div><!-- /.table-wrapper -->

  <!-- Pagination (unchanged) -->
  <!-- table-control.component.html -->
  <!-- ... previous content remains the same until the pagination section ... -->

  <!-- Pagination -->
  <nav *ngIf="totalPages > 1" [class.pagination-disabled]="pageDataReloadMode === 'loading'">
    <ul class="pagination justify-content-center">
      <!-- First Page Button -->
      <li class="page-item" [class.disabled]="currentPage === 1 || pageDataReloadMode === 'loading'">
        <a class="page-link" href="javascript:void(0)" (click)="pageDataReloadMode !== 'loading' && goToPage(1)" title="First Page">
          &laquo;
        </a>
      </li>

      <!-- Previous Page Button -->
      <li class="page-item" [class.disabled]="currentPage === 1 || pageDataReloadMode === 'loading'">
        <a class="page-link" href="javascript:void(0)" (click)="pageDataReloadMode !== 'loading' && prevPage()" title="Previous">
          &lsaquo;
        </a>
      </li>

      <!-- Page Numbers -->
      <li class="page-item" *ngFor="let page of getPageRange()" [class.active]="currentPage === page" [class.disabled]="pageDataReloadMode === 'loading'">
        <a class="page-link" href="javascript:void(0)" (click)="pageDataReloadMode !== 'loading' && goToPage(page)">
          {{ page }}
        </a>
      </li>

      <!-- Next Page Button -->
      <li class="page-item" [class.disabled]="currentPage === totalPages || pageDataReloadMode === 'loading'">
        <a class="page-link" href="javascript:void(0)" (click)="pageDataReloadMode !== 'loading' && nextPage()" title="Next">
          &rsaquo;
        </a>
      </li>

      <!-- Last Page Button -->
      <li class="page-item" [class.disabled]="currentPage === totalPages || pageDataReloadMode === 'loading'">
        <a class="page-link" href="javascript:void(0)" (click)="pageDataReloadMode !== 'loading' && goToPage(totalPages)" title="Last Page">
          &raquo;
        </a>
      </li>
    </ul>
  </nav>
</div>
